<template>
  <div>
    <h1>Terms of Service</h1>
    <p>Here’s all the legal blah blah...</p>
  </div>
</template>

<!--<script>-->
<!--import BackButton from '@/components/BackButton.vue';-->

<!--export default {-->
<!--  components: { BackButton },-->
<!--};-->
<!--</script>-->